import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../apiBase';
import { isSessionValid, saveSession } from '../auth';

const Login = ({ setIsAuthenticated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (isSessionValid()) {
      setIsAuthenticated(true);
      navigate('/dashboard', { replace: true });
    }
  }, [navigate, setIsAuthenticated]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE}/login`, {
        email,
        password,
      });

      const { id_account_caisse, id_caisse } = response.data;
      saveSession({ id_account_caisse, id_caisse });
      setIsAuthenticated(true);
      // Always land on dashboard so accounts without "Caisse" (or any other
      // previous point de préparation) are not sent to the wrong kitchen screen.
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Server error');
    }
  };

  return (
    <div className="login-container">
      <div className="background-effects">
        <div className="overlay"></div>
      </div>
      <div className="login-card animate-slide-in">
        <div className="card-header">
          <div className="logo">
            <img 
              src="/lacaisse_logo.png" 
              alt="La Caisse Logo" 
              style={{ width: '170px', height: 'auto' }}
            />
          </div>
        </div>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <span className="floating-label">Email Address</span>
            <span className="input-underline"></span>
          </div>
          <div className="form-group">
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="floating-label">Password</span>
            <span className="input-underline"></span>
          </div>
          {error && <p className="error-message animate-error">{error}</p>}
          <button type="submit" className="luxury-btn">
            <span>LOGIN</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;